import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=14891df9&scoped=true"
import script from "./JSONEditor.vue?vue&type=script&lang=js"
export * from "./JSONEditor.vue?vue&type=script&lang=js"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=14891df9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14891df9",
  null
  
)

export default component.exports